module.exports = __webpack_public_path__ + "img/birthday-cake-emoji.68b982cb.png";